import { IconButton } from "@mui/material";
import * as React from "react"
import { Board } from "./CoState"
import { make as UnitImageExtended } from "common/src/tft-static/UnitImageExtended.bs.js"
import UnitImage from "common/src/tft-static/UnitImage"
import AugmentImage from "common/src/tft-static/AugmentImage"
import { make as PlExpandedMatch } from "../player2/PlExpandedMatch.bs.js"
import OpenInFull from "@mui/icons-material/OpenInFull";
import { make as PositionSquare } from "../player/PositionSquare.bs.js"

type BoardProps = {
  board: Board,
  setExpandedMatchId: (id: string) => void;
  idx: number;
}

const Board = ({
  board,
  setExpandedMatchId,
  idx,
}: BoardProps) => {
  return (
    <div className={`flex items-center px-4 py-5 ${idx % 2 === 1 ? "bg-bg2" : ""}`}>
      <PositionSquare pl={board.place} />
      <div className="flex gap-2 pl-5">
        {board.augments.map(augId => (
          <AugmentImage key={augId} augId={augId} size={42} />
        ))}
      </div>
      <div className="grid grid-cols-10 gap-2 gap-y-4 pl-5">
        {board.units.map(([unitId, starLevel, items], idx) => (
          <UnitImageExtended key={idx} unitId={unitId} starLevel={starLevel + 1} items={items} size={42} />
        ))}
      </div>
      <div className="ml-auto">
        <IconButton onClick={() => {
          setExpandedMatchId(board.matchId)
        }}>
          <OpenInFull />
        </IconButton>
      </div>
    </div>
  )
}

type Props = {
  matches: Array<Board>;
  search: string;
};

const CoBoards = ({
  search,
  matches,
}: Props) => {
  const [expandedMatchId, setExpandedMatchId] = React.useState<undefined | string>(() => undefined)

  return (
    <div className="py-2">
      {matches.map((board, idx) => (
        <Board key={idx} board={board} setExpandedMatchId={setExpandedMatchId} idx={idx} />
      ))}
      <PlExpandedMatch expandedMatchId={expandedMatchId} onClose={() => setExpandedMatchId(undefined)} />
    </div>
  )
}

export default CoBoards;
